module.exports = __webpack_public_path__ + "c4c455beb55bf536917c5e235b9100a2.pdf";